const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CHF: "CHF",
  CAD: "C$",
  AUD: "A$",
  CNY: "¥",
}

export const getCurrencySymbol = (code: string | null | undefined): string => {
  if (!code) return "$"
  return CURRENCY_SYMBOLS[code] || code
}

export const formatCurrency = (value: number, currencyCode?: string | null): string => {
  const symbol = getCurrencySymbol(currencyCode)
  if (Math.abs(value) >= 1e9) {
    return `${(value / 1e9).toFixed(1)}B ${symbol}`
  }
  if (Math.abs(value) >= 1e6) {
    return `${(value / 1e6).toFixed(1)}M ${symbol}`
  }
  if (Math.abs(value) >= 1e3) {
    return `${(value / 1e3).toFixed(1)}K ${symbol}`
  }
  return `${value.toFixed(0)} ${symbol}`
}

export const formatPercentage = (value: number, total: number): string => {
  if (total === 0) return "0%"
  return `${((value / total) * 100).toFixed(1)}%`
}
